import React, {Component} from 'react';
import './FormV2.css';

/**
 * Form V2. Does not add background or border radius to top level element.
 *
 * Also doesnt use html form element
 */
const FormV2 = props => <div className={`FormV2 ${props.className || ''}`}>{props.children}</div>;

export default FormV2;



// WEBPACK FOOTER //
// ./src/widgets/FormV2.js